// Touch sizing keyed off the input device, not the viewport: landscape iPads
// (1180px+) exceed the `lg` breakpoint yet are still touch-driven, so a
// width-only rule would shrink their controls below the 44px target (AC6).
export const COARSE_POINTER = '@media (pointer: coarse)'

export const TOUCH_TARGET_PX = 44
